import { render, staticRenderFns } from "./AyudaDxView.vue?vue&type=template&id=7bef3af9"
import script from "./AyudaDxView.vue?vue&type=script&lang=js"
export * from "./AyudaDxView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports